export default {
      id: "bar-chart-activ-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#bar-chart-activ",
      toString: function () {
        return this.url;
      }
    }